import Player from "./player"

class PlayerHuman extends Player {
  constructor(id, infos, discX, senseDiscX, discY, senseDiscY, game, cardKey, discKey, maxWidth, maxHeight) {
    super(id, infos, discX, senseDiscX, discY, senseDiscY, game, maxWidth, maxHeight)
    this.typePlayer = "human"
    this.cardKey = cardKey
    this.discKey = discKey
    this._setListeners()
  }

  updateCurrentCard() {
    super.updateCurrentCard()
  }

  updateCounterCards() {
    super.updateCounterCards()
  }

  throwCard() {
    super.throwCard()
  }

  throwDisc(){
    super.throwDisc()
  }

  _setListeners() {
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === this.cardKey) {
        console.log(`cardKey ${this.username} pressed`)
        this.throwCard()
      } else if (e.keyCode === this.discKey) {
        console.log(`discKey ${this.username} pressed`)
        this.throwDisc()
      }
    })
  }

}

export default PlayerHuman;